module.exports = __webpack_public_path__ + "media/images/landing/icons/twitter-304c70976bed4e41c98febc84ea9656b.svg";